document.addEventListener("DOMContentLoaded", initWishlistOrder);

document.addEventListener("shopify:section:load", initWishlistOrder);

function initWishlistOrder() {

    const moveWishlist = () => {

        const wishlist = document.querySelector(".Vtl-WishlistHeaderWrapper");

        const account = document.querySelector(".account-popover, .account-drawer");

        if (!wishlist || !account) return;

        if (wishlist.dataset.moved) return;

        account.parentNode.insertBefore(wishlist, account);

        wishlist.dataset.moved = "true";

    };

    moveWishlist();

    const observer = new MutationObserver(moveWishlist);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

}